import { Component } from '@angular/core';
import { Button } from '../button/button';
import { RouterLink } from '@angular/router';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-footer',
  imports: [Button, RouterLink, FormsModule],
  templateUrl: './footer.html',
  styleUrl: './footer.scss'
})
export class Footer {

  public newsletter = {
    name: '',
    email: ''
  };

  subscribe() {
    if (!this.newsletter.name || !this.newsletter.email) return;
    //TODO sent email and name to subcribe
    this.newsletter = {
      name: '',
      email: ''
    };
  }

}
